import React, { useEffect } from "react";
import { Modal, Form, Input, Row, Col, Card, Select, Avatar } from "antd";
import { DepartementService } from "../../services/DepartementService";
import { catchError } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import CustomFormItem from "../utils/form/CustomFormItem";
import { PersonnelService } from "../../services/PersonnelService";

const DepartementEditForm = ({ visible, uid, onUpdate, onCancel }) => {
  const [form] = Form.useForm();
  const [editing, setEditing] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [personnels, setPersonnels] = React.useState([]);
  const [departements, setDepartements] = React.useState([]);

  useEffect(() => {
    if (!visible) return;
    setLoading(true);
    Promise.all([
      DepartementService.getInstance().all(),
      PersonnelService.getInstance().all(),
    ])
      .then(([departementData, personnelData]) => {
        setDepartements(departementData.data);
        setPersonnels(personnelData.data);
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [visible]);

  useEffect(() => {
    if (uid) {
      setEditing(true);
      DepartementService.getInstance()
        .find(uid)
        .then((response) => {
          form.setFieldsValue(response.data);
        })
        .catch((error) => {
          catchError(error);
        })
        .finally(() => {
          setEditing(false);
        });
    }
  }, [uid, form]);

  const handleSave = () => {
    setEditing(true);
    form
      .validateFields()
      .then((values) => {
        DepartementService.getInstance()
          .update(uid, values)
          .then((response) => {
            Toast.success(response.message);
            onUpdate(response.data);
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setEditing(false);
          });
      })
      .catch(() => {
        setEditing(false);
      });
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      okText="Enregistrer"
      onOk={handleSave}
      title="Modifier département"
      forceRender
    >
      <Card loading={editing} style={{ marginBottom: 20 }}>
        <Form
          layout="vertical"
          form={form}
          name="editDepartementForm"
          initialValues={{
            enabled: 1,
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Nom"
                name="nom"
                rules={[{ required: true, message: "Veuillez saisir le nom!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Code"
                name="code"
                rules={[{ required: true, message: "Veuillez saisir le code!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Departement Parent"
                name="departement_id"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Select options={departements.map((departement) => ({
                  label: `${departement.nom} (${departement.code})`, value: departement.id
                }))} showSearch optionFilterProp="label" loading={loading} allowClear />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Responsable Actuel"
                name="personnel_id"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Select allowClear options={personnels.map((personnel) => ({
                  label: <>
                  <Avatar src={personnel.avatar_link} /> {personnel.name}
                  </>, value: personnel.id, name: personnel.name
                }))} showSearch optionFilterProp="name" loading={loading} />
              </CustomFormItem>
            </Col>
          </Row>

        </Form>
      </Card>
    </Modal>
  );
};

export default DepartementEditForm;

DepartementEditForm.propTypes = {
  visible: PropTypes.bool,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func,
  uid: PropTypes.string.isRequired
};
